import { render, staticRenderFns } from "./RuleEvaluationsTab.vue?vue&type=template&id=4d7d7b93&"
import script from "./RuleEvaluationsTab.vue?vue&type=script&lang=js&"
export * from "./RuleEvaluationsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDataTable,VSpacer})
